export default "__VITE_ASSET__Bmnk6K8i__"